var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLayoutFluid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_318_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 9.16667H10.8333C11.2754 9.16667 11.6993 8.99107 12.0118 8.67851C12.3244 8.36595 12.5 7.94203 12.5 7.5V1.66667C12.5 1.22464 12.3244 0.800716 12.0118 0.488155C11.6993 0.175595 11.2754 0 10.8333 0L1.66667 0C1.22464 0 0.800716 0.175595 0.488155 0.488155C0.175595 0.800716 0 1.22464 0 1.66667L0 7.5C0 7.94203 0.175595 8.36595 0.488155 8.67851C0.800716 8.99107 1.22464 9.16667 1.66667 9.16667ZM1.66667 1.66667H10.8333V7.5H1.66667V1.66667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 -7.62939e-06H15.8333C15.3913 -7.62939e-06 14.9674 0.175587 14.6548 0.488148C14.3423 0.800708 14.1667 1.22463 14.1667 1.66666V7.49999C14.1667 7.94202 14.3423 8.36594 14.6548 8.6785C14.9674 8.99106 15.3913 9.16666 15.8333 9.16666H18.3333C18.7754 9.16666 19.1993 8.99106 19.5118 8.6785C19.8244 8.36594 20 7.94202 20 7.49999V1.66666C20 1.22463 19.8244 0.800708 19.5118 0.488148C19.1993 0.175587 18.7754 -7.62939e-06 18.3333 -7.62939e-06ZM18.3333 7.49999H15.8333V1.66666H18.3333V7.49999Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 10.8333H1.66667C1.22464 10.8333 0.800716 11.0089 0.488155 11.3215C0.175595 11.6341 0 12.058 0 12.5L0 18.3333C0 18.7754 0.175595 19.1993 0.488155 19.5118C0.800716 19.8244 1.22464 20 1.66667 20H4.16667C4.60869 20 5.03262 19.8244 5.34518 19.5118C5.65774 19.1993 5.83333 18.7754 5.83333 18.3333V12.5C5.83333 12.058 5.65774 11.6341 5.34518 11.3215C5.03262 11.0089 4.60869 10.8333 4.16667 10.8333ZM4.16667 18.3333H1.66667V12.5H4.16667V18.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 10.8333H9.16667C8.72464 10.8333 8.30072 11.0089 7.98816 11.3215C7.6756 11.6341 7.5 12.058 7.5 12.5V18.3333C7.5 18.7754 7.6756 19.1993 7.98816 19.5118C8.30072 19.8244 8.72464 20 9.16667 20H18.3333C18.7754 20 19.1993 19.8244 19.5118 19.5118C19.8244 19.1993 20 18.7754 20 18.3333V12.5C20 12.058 19.8244 11.6341 19.5118 11.3215C19.1993 11.0089 18.7754 10.8333 18.3333 10.8333ZM18.3333 18.3333H9.16667V12.5H18.3333V18.3333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_318_533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "black"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayoutFluid);
export default __webpack_public_path__ + "static/media/LayoutFluid.27544adb2947a2f7b7ee67e6dffbc114.svg";
export { ForwardRef as ReactComponent };